/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AccessDeniedImport } from './routes/access-denied'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as SetPasswordTokenImport } from './routes/set-password.$token'
import { Route as AuthStatisticsIndexImport } from './routes/_auth/statistics/index'
import { Route as AuthGameSessionsIndexImport } from './routes/_auth/game-sessions/index'
import { Route as AuthGameSessionIndexImport } from './routes/_auth/game-session/index'
import { Route as AuthFriendsIndexImport } from './routes/_auth/friends/index'
import { Route as AuthDashboardIndexImport } from './routes/_auth/dashboard/index'
import { Route as AuthFriendsClaimImport } from './routes/_auth/friends/claim'
import { Route as AuthFriendsAddImport } from './routes/_auth/friends/add'
import { Route as AuthGameSessionGameSessionIdIndexImport } from './routes/_auth/game-session/$gameSessionId/index'
import { Route as AuthDashboardUserSettingsIndexImport } from './routes/_auth/dashboard/user-settings/index'
import { Route as AuthDashboardUserSettingsDetailsImport } from './routes/_auth/dashboard/user-settings/details'
import { Route as AuthDashboardUserSettingsAvatarImport } from './routes/_auth/dashboard/user-settings/avatar'
import { Route as AuthGameSessionGameSessionIdScoreTakingIndexImport } from './routes/_auth/game-session/$gameSessionId/score-taking/index'
import { Route as AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport } from './routes/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
import { Route as AuthGameSessionGameSessionIdScoreTakingSessionActionsImport } from './routes/_auth/game-session/$gameSessionId/score-taking/session-actions'
import { Route as AuthGameSessionGameSessionIdScoreTakingFinishImport } from './routes/_auth/game-session/$gameSessionId/score-taking/finish'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesCreateImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/create'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/index'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRoute = AccessDeniedImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SetPasswordTokenRoute = SetPasswordTokenImport.update({
  id: '/set-password/$token',
  path: '/set-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthStatisticsIndexRoute = AuthStatisticsIndexImport.update({
  id: '/statistics/',
  path: '/statistics/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionsIndexRoute = AuthGameSessionsIndexImport.update({
  id: '/game-sessions/',
  path: '/game-sessions/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionIndexRoute = AuthGameSessionIndexImport.update({
  id: '/game-session/',
  path: '/game-session/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsIndexRoute = AuthFriendsIndexImport.update({
  id: '/friends/',
  path: '/friends/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardIndexRoute = AuthDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsClaimRoute = AuthFriendsClaimImport.update({
  id: '/friends/claim',
  path: '/friends/claim',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsAddRoute = AuthFriendsAddImport.update({
  id: '/friends/add',
  path: '/friends/add',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionGameSessionIdIndexRoute =
  AuthGameSessionGameSessionIdIndexImport.update({
    id: '/game-session/$gameSessionId/',
    path: '/game-session/$gameSessionId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsIndexRoute =
  AuthDashboardUserSettingsIndexImport.update({
    id: '/dashboard/user-settings/',
    path: '/dashboard/user-settings/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsDetailsRoute =
  AuthDashboardUserSettingsDetailsImport.update({
    id: '/dashboard/user-settings/details',
    path: '/dashboard/user-settings/details',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsAvatarRoute =
  AuthDashboardUserSettingsAvatarImport.update({
    id: '/dashboard/user-settings/avatar',
    path: '/dashboard/user-settings/avatar',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingIndexRoute =
  AuthGameSessionGameSessionIdScoreTakingIndexImport.update({
    id: '/game-session/$gameSessionId/score-taking/',
    path: '/game-session/$gameSessionId/score-taking/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute =
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport.update({
    id: '/game-session/$gameSessionId/score-taking/tiebreak-win',
    path: '/game-session/$gameSessionId/score-taking/tiebreak-win',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute =
  AuthGameSessionGameSessionIdScoreTakingSessionActionsImport.update({
    id: '/game-session/$gameSessionId/score-taking/session-actions',
    path: '/game-session/$gameSessionId/score-taking/session-actions',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingFinishRoute =
  AuthGameSessionGameSessionIdScoreTakingFinishImport.update({
    id: '/game-session/$gameSessionId/score-taking/finish',
    path: '/game-session/$gameSessionId/score-taking/finish',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesCreateImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/create',
    path: '/game-session/$gameSessionId/score-taking/games/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/',
    path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete',
    path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete',
    getParentRoute: () => AuthRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/set-password/$token': {
      id: '/set-password/$token'
      path: '/set-password/$token'
      fullPath: '/set-password/$token'
      preLoaderRoute: typeof SetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/friends/add': {
      id: '/_auth/friends/add'
      path: '/friends/add'
      fullPath: '/friends/add'
      preLoaderRoute: typeof AuthFriendsAddImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/claim': {
      id: '/_auth/friends/claim'
      path: '/friends/claim'
      fullPath: '/friends/claim'
      preLoaderRoute: typeof AuthFriendsClaimImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/': {
      id: '/_auth/friends/'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AuthFriendsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/': {
      id: '/_auth/game-session/'
      path: '/game-session'
      fullPath: '/game-session'
      preLoaderRoute: typeof AuthGameSessionIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-sessions/': {
      id: '/_auth/game-sessions/'
      path: '/game-sessions'
      fullPath: '/game-sessions'
      preLoaderRoute: typeof AuthGameSessionsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/statistics/': {
      id: '/_auth/statistics/'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthStatisticsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/avatar': {
      id: '/_auth/dashboard/user-settings/avatar'
      path: '/dashboard/user-settings/avatar'
      fullPath: '/dashboard/user-settings/avatar'
      preLoaderRoute: typeof AuthDashboardUserSettingsAvatarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/details': {
      id: '/_auth/dashboard/user-settings/details'
      path: '/dashboard/user-settings/details'
      fullPath: '/dashboard/user-settings/details'
      preLoaderRoute: typeof AuthDashboardUserSettingsDetailsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/': {
      id: '/_auth/dashboard/user-settings/'
      path: '/dashboard/user-settings'
      fullPath: '/dashboard/user-settings'
      preLoaderRoute: typeof AuthDashboardUserSettingsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/': {
      id: '/_auth/game-session/$gameSessionId/'
      path: '/game-session/$gameSessionId'
      fullPath: '/game-session/$gameSessionId'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/finish': {
      id: '/_auth/game-session/$gameSessionId/score-taking/finish'
      path: '/game-session/$gameSessionId/score-taking/finish'
      fullPath: '/game-session/$gameSessionId/score-taking/finish'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingFinishImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/session-actions': {
      id: '/_auth/game-session/$gameSessionId/score-taking/session-actions'
      path: '/game-session/$gameSessionId/score-taking/session-actions'
      fullPath: '/game-session/$gameSessionId/score-taking/session-actions'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win': {
      id: '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
      path: '/game-session/$gameSessionId/score-taking/tiebreak-win'
      fullPath: '/game-session/$gameSessionId/score-taking/tiebreak-win'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/': {
      id: '/_auth/game-session/$gameSessionId/score-taking/'
      path: '/game-session/$gameSessionId/score-taking'
      fullPath: '/game-session/$gameSessionId/score-taking'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/create': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/create'
      path: '/game-session/$gameSessionId/score-taking/games/create'
      fullPath: '/game-session/$gameSessionId/score-taking/games/create'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      fullPath: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/'
      path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
      fullPath: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthFriendsAddRoute: typeof AuthFriendsAddRoute
  AuthFriendsClaimRoute: typeof AuthFriendsClaimRoute
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
  AuthFriendsIndexRoute: typeof AuthFriendsIndexRoute
  AuthGameSessionIndexRoute: typeof AuthGameSessionIndexRoute
  AuthGameSessionsIndexRoute: typeof AuthGameSessionsIndexRoute
  AuthStatisticsIndexRoute: typeof AuthStatisticsIndexRoute
  AuthDashboardUserSettingsAvatarRoute: typeof AuthDashboardUserSettingsAvatarRoute
  AuthDashboardUserSettingsDetailsRoute: typeof AuthDashboardUserSettingsDetailsRoute
  AuthDashboardUserSettingsIndexRoute: typeof AuthDashboardUserSettingsIndexRoute
  AuthGameSessionGameSessionIdIndexRoute: typeof AuthGameSessionGameSessionIdIndexRoute
  AuthGameSessionGameSessionIdScoreTakingFinishRoute: typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute: typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute: typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  AuthGameSessionGameSessionIdScoreTakingIndexRoute: typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFriendsAddRoute: AuthFriendsAddRoute,
  AuthFriendsClaimRoute: AuthFriendsClaimRoute,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
  AuthFriendsIndexRoute: AuthFriendsIndexRoute,
  AuthGameSessionIndexRoute: AuthGameSessionIndexRoute,
  AuthGameSessionsIndexRoute: AuthGameSessionsIndexRoute,
  AuthStatisticsIndexRoute: AuthStatisticsIndexRoute,
  AuthDashboardUserSettingsAvatarRoute: AuthDashboardUserSettingsAvatarRoute,
  AuthDashboardUserSettingsDetailsRoute: AuthDashboardUserSettingsDetailsRoute,
  AuthDashboardUserSettingsIndexRoute: AuthDashboardUserSettingsIndexRoute,
  AuthGameSessionGameSessionIdIndexRoute:
    AuthGameSessionGameSessionIdIndexRoute,
  AuthGameSessionGameSessionIdScoreTakingFinishRoute:
    AuthGameSessionGameSessionIdScoreTakingFinishRoute,
  AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute:
    AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute,
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute:
    AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute,
  AuthGameSessionGameSessionIdScoreTakingIndexRoute:
    AuthGameSessionGameSessionIdScoreTakingIndexRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/game-session/$gameSessionId/score-taking': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/game-session/$gameSessionId/score-taking': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/_auth/friends/add': typeof AuthFriendsAddRoute
  '/_auth/friends/claim': typeof AuthFriendsClaimRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_auth/friends/': typeof AuthFriendsIndexRoute
  '/_auth/game-session/': typeof AuthGameSessionIndexRoute
  '/_auth/game-sessions/': typeof AuthGameSessionsIndexRoute
  '/_auth/statistics/': typeof AuthStatisticsIndexRoute
  '/_auth/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/_auth/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/_auth/dashboard/user-settings/': typeof AuthDashboardUserSettingsIndexRoute
  '/_auth/game-session/$gameSessionId/': typeof AuthGameSessionGameSessionIdIndexRoute
  '/_auth/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/_auth/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/_auth/game-session/$gameSessionId/score-taking/': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/friends/add'
    | '/friends/claim'
    | '/dashboard'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/dashboard/user-settings'
    | '/game-session/$gameSessionId'
    | '/game-session/$gameSessionId/score-taking/finish'
    | '/game-session/$gameSessionId/score-taking/session-actions'
    | '/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/game-session/$gameSessionId/score-taking'
    | '/game-session/$gameSessionId/score-taking/games/create'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/friends/add'
    | '/friends/claim'
    | '/dashboard'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/dashboard/user-settings'
    | '/game-session/$gameSessionId'
    | '/game-session/$gameSessionId/score-taking/finish'
    | '/game-session/$gameSessionId/score-taking/session-actions'
    | '/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/game-session/$gameSessionId/score-taking'
    | '/game-session/$gameSessionId/score-taking/games/create'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/_auth/friends/add'
    | '/_auth/friends/claim'
    | '/_auth/dashboard/'
    | '/_auth/friends/'
    | '/_auth/game-session/'
    | '/_auth/game-sessions/'
    | '/_auth/statistics/'
    | '/_auth/dashboard/user-settings/avatar'
    | '/_auth/dashboard/user-settings/details'
    | '/_auth/dashboard/user-settings/'
    | '/_auth/game-session/$gameSessionId/'
    | '/_auth/game-session/$gameSessionId/score-taking/finish'
    | '/_auth/game-session/$gameSessionId/score-taking/session-actions'
    | '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/_auth/game-session/$gameSessionId/score-taking/'
    | '/_auth/game-session/$gameSessionId/score-taking/games/create'
    | '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordTokenRoute: typeof SetPasswordTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordTokenRoute: SetPasswordTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/access-denied",
        "/login",
        "/logout",
        "/register",
        "/reset-password",
        "/set-password/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/friends/add",
        "/_auth/friends/claim",
        "/_auth/dashboard/",
        "/_auth/friends/",
        "/_auth/game-session/",
        "/_auth/game-sessions/",
        "/_auth/statistics/",
        "/_auth/dashboard/user-settings/avatar",
        "/_auth/dashboard/user-settings/details",
        "/_auth/dashboard/user-settings/",
        "/_auth/game-session/$gameSessionId/",
        "/_auth/game-session/$gameSessionId/score-taking/finish",
        "/_auth/game-session/$gameSessionId/score-taking/session-actions",
        "/_auth/game-session/$gameSessionId/score-taking/tiebreak-win",
        "/_auth/game-session/$gameSessionId/score-taking/",
        "/_auth/game-session/$gameSessionId/score-taking/games/create",
        "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete",
        "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/"
      ]
    },
    "/access-denied": {
      "filePath": "access-denied.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/set-password/$token": {
      "filePath": "set-password.$token.tsx"
    },
    "/_auth/friends/add": {
      "filePath": "_auth/friends/add.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/claim": {
      "filePath": "_auth/friends/claim.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/": {
      "filePath": "_auth/dashboard/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/": {
      "filePath": "_auth/friends/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/": {
      "filePath": "_auth/game-session/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-sessions/": {
      "filePath": "_auth/game-sessions/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/statistics/": {
      "filePath": "_auth/statistics/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/avatar": {
      "filePath": "_auth/dashboard/user-settings/avatar.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/details": {
      "filePath": "_auth/dashboard/user-settings/details.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/": {
      "filePath": "_auth/dashboard/user-settings/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/": {
      "filePath": "_auth/game-session/$gameSessionId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/finish": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/finish.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/session-actions": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/session-actions.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/tiebreak-win": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/tiebreak-win.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/create": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
